import * as lodash from 'lodash';

/**
 * "Ciao ${displayName}".interpolate(player) -> "Ciao Stefano"
 */
String.prototype.interpolate = function (args) {
  const templateLiteral = lodash.template(this.toString());
  return templateLiteral(args);
};
